<template>
  <c-button
    unelevated
    v-bind="$attrs"
    :size="size"
    :padding="padding"
    :class="buttonClasses"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </c-button>
</template>

<script setup lang="ts">
import { computed } from "vue";

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<{
    size?: "sm" | "md";
  }>(),
  {
    size: "md",
  },
);

const padding = computed(() => (props.size === "sm" ? "4px 6px" : "8px 10px"));

const buttonClasses = computed(() => ({
  "tw-h-[40px] !tw-min-w-[40px]": props.size === "md",
  "tw-h-[28px] !tw-min-w-[28px]": props.size === "sm",
}));
</script>
